import React from 'react';

import Egg from "../images/egg.png";

const NotFound = () => {
  return (
    <div className="px-4 py-5 container-fluid">
      <div className="row no-gutters">
        <div className="col-12 col-md-10 offset-md-1">    
          <div className="text-center">
            <h2 className="text-warning">404</h2>
            <span>Page was not found!</span>
          </div>  
          <img className="mx-auto mt-5" src={Egg} alt="404 page not found" />
        </div>
      </div>
    </div>
  );
}

export default NotFound;